import { FunctionComponent } from 'react';

import Loader from '@Components/Loader';

import { StyledBox } from './FullScreenLoader.styles';
import { FullScreenLoaderProps } from './FullScreenLoader.types';

const FullScreenLoader: FunctionComponent<FullScreenLoaderProps> = (
  props: FullScreenLoaderProps
): JSX.Element => {
  const { LoaderProps, ...resProps } = props;
  return (
    <StyledBox {...resProps}>
      <Loader {...LoaderProps} />
    </StyledBox>
  );
};
export default FullScreenLoader;
